export const formatSize = (size?: number) => {
  if (!size) return 'Unknown';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return `${size} ${units[i]}`;
};

export const formatDate = (date?: Date) => {
  if (!date) return 'Unknown';
  return (
    new Date(date).toLocaleDateString() +
    ' ' +
    new Date(date).toLocaleTimeString()
  );
};
